/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import AllTasksView from "layouts/all-tasks-view";
import AddNewTask from "layouts/add-new-task";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import TeamDevColibri from "layouts/team-motobudrex";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import WebsiteControl from "layouts/website-control";

// import TaskView from "layouts/task-view";
import TaskView from "layouts/task-view";

// @mui icons
import Icon from "@mui/material/Icon";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import CloudIcon from '@mui/icons-material/Cloud';
import CodeIcon from '@mui/icons-material/Code';
import WidgetsIcon from '@mui/icons-material/Widgets';
import PublicIcon from '@mui/icons-material/Public';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import RocketIcon from '@mui/icons-material/Rocket';
import LanguageIcon from '@mui/icons-material/Language';
import { OpenInNewRounded } from "@mui/icons-material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
// import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
// import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

const routes = [
  {
    // type: "collapse",
    // name: "Strona główna",
    // key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Zadania",
    key: "tasks",
    // icon: <Icon fontSize="small">table_view</Icon>,
    icon: <TaskAltIcon fontSize="medium" />,
    route: "/tasks",
    component: <AllTasksView />,
  },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  {
    // type: "collapse",
    // name: "RTL",
    // key: "rtl",
    // icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    // route: "/rtl",
    // component: <RTL />,
  },
  {
    type: "collapse",
    name: "Dodaj zadanie",
    key: "addNewTask",
    icon: <AddTaskIcon fontSize="medium" />,
    route: "/addNewTask",
    component: <AddNewTask />,
  },
  {
    // type: "collapse",
    name: "Otwarte zadanie",
    key: "task-view",
    icon: <OpenInNewRounded fontSize="medium" />,
    route: "/task-view",
    component: <TaskView />,
  },
  {
    // type: "collapse",
    name: "Powiadomienia",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    // type: "collapse",
    name: "Zespół DevColibri",
    key: "team",
    icon: <Diversity3Icon fontSize="small" />,
    route: "/team",
    component: <TeamDevColibri />,
  },
  {
    // type: "collapse",
    // name: "Profile",
    // key: "profile",
    // icon: <Icon fontSize="small">person</Icon>,
    // route: "/profile",
    // component: <Profile />,
  },
  {
    // type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    // type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    // type: "collapse",
    // name: "Zarządzanie stroną",
    // key: "website-control",
    // icon: <RocketLaunchIcon fontSize="medium" />,
    // route: "/website-control",
    // component: <WebsiteControl />,
  },
  {
    // type: "collapse",
    // name: "Zarządzanie profilami",
    // key: "users-rights",
    // icon: <AdminPanelSettingsIcon fontSize="medium" />,
    // route: "/authentication/sign-up",
    // component: <SignUp />,
  },
];

export default routes;
